export default __webpack_public_path__ + "static/media/playGif.058864bd.gif";